

import { useState, useEffect } from 'react';
import { userAPI, handleApiError } from '../services/api';

export const useProfile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchProfile();
  }, []);
  
  const fetchProfile = async () => {
    try {
      setLoading(true);
      const res = await userAPI.getUserInfo();
      setProfile(res.data);
    } catch (err) {
      setError(error?.response?.data?.error);
    } finally {
      setLoading(false);
    }
  };

  return { profile, loading, error, fetchProfile};
};